import Hls from "hls.js";
import { HLS_EXTENSION } from "./constants";

export const isHlsSupported = (playbackUrl: string) =>
  Hls.isSupported() && playbackUrl.toLowerCase().endsWith(HLS_EXTENSION);
